import { Component, EventEmitter, Output, signal } from '@angular/core';
import { SectionService } from '../../../services/section.service';
import { Section } from '@mira-avant/mtlibs';
import { ClientService } from '../../../services/client.service';
import { AuthService } from '../../../services/auth.service';
import { NzSpinComponent } from 'ng-zorro-antd/spin';
import { CourseTitleComponent } from '../journey/course-title/course-title.component';

@Component({
	selector: 'app-quick-enroll',
	imports: [NzSpinComponent, CourseTitleComponent],
	standalone: true,
	templateUrl: './quick-enroll.html',
	styleUrl: './quick-enroll.scss',
})
export class QuickEnroll {
	@Output('enrollInSection') public enrollInSectionEmitter: EventEmitter<Section> = new EventEmitter<Section>();
	public sections = signal<Section[]>([]);
	public sectionsUuidsAlreadyEnrolled = signal<string[]>([]);
	public loading = signal<boolean>(true);
	public isAdmin = signal<boolean>(false);

	constructor(
		private sectionService: SectionService,
		private authService: AuthService,
		private clientService: ClientService
	) {}

	async ngOnInit(): Promise<void> {
		this.isAdmin.set(await this.authService.isAdmin$());

		try {
			this.loading.set(true);

			const client = await this.clientService.getClientBySubDomain$();

			if (client) {
				this.sections.set(await this.sectionService.getSectionsByClient$(client.uuid, 0, 100, false));
			}

			await this.refreshSectionsAlreadyEnrolled();
		} catch (error) {
			console.error('Error loading sections:', error);
		} finally {
			this.loading.set(false);
		}
	}

	private async refreshSectionsAlreadyEnrolled(): Promise<void> {
		this.sectionsUuidsAlreadyEnrolled.set(
			await this.sectionService.getMySections$(0, 100).then(sections => sections.map(section => section.uuid))
		);
	}

	public async enrollInSection(section: Section): Promise<void> {
		this.loading.set(true);

		try {
			const tokenPack = await this.authService.getCurrentTokenPack();

			if (!tokenPack || !tokenPack.cognitoUser) {
				return;
			}

			await this.sectionService.addUserToSection$(section.uuid, tokenPack.cognitoUser.uuid);

			await this.refreshSectionsAlreadyEnrolled();

			this.enrollInSectionEmitter.emit(section);
		} catch (error) {
			console.error('Error enrolling in section:', error);
		} finally {
			this.loading.set(false);
		}
	}
}
